import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { BusinessCategory } from '@barboxx/models';

interface Props {
    businessCategory: BusinessCategory.DetailsResponse;
}

export const BusinessCategoryDeleteCard = ({ businessCategory }: Props) => {
    const notification = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteBusinessCategory = useMutation({
        mutationKey: ['deleteBusinessCategory', businessCategory.id],
        mutationFn: () =>
            Api.BusinessSpecific.Category.deleteCategory(businessCategory),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this business category!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete business category',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteBusinessCategory
            .mutateAsync()
            .then(({ data }) => {
                notification.show('Deleted business category!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notification.show('Error Deleting business category!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete BusinessCategory" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this business category?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
